<template>
  <el-date-picker
    v-model="dates"
    :picker-options="pickerOptions"
    :clearable="false"
    :editable="false"
    type="datetimerange"
    start-placeholder="开始时间"
    end-placeholder="结束时间"
    range-separator="至"
    value-format="yyyy-MM-dd HH:mm:ss"
    :default-time="['00:00:00', '23:59:59']"
    placeholder="选择日期">
  </el-date-picker>
</template>

<script>
  export default {
    data() {
      return {
        dates: this.dateValue,
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > new Date((new Date()).getFullYear(), (new Date()).getMonth(), (new Date()).getDate(), 23, 59, 59).getTime();
          },
          shortcuts: [
            {
              text: '当天',
              onClick(picker) {
                let start = new Date();
                start = new Date(start.getFullYear(), start.getMonth(), start.getDate(), 0, 0, 0)
                const end = new Date(start.getFullYear(), start.getMonth(), start.getDate(), 23, 59, 59);
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: '最近一周',
              onClick(picker) {
                let end = new Date();
                end = new Date(end.getFullYear(), end.getMonth(), end.getDate(), 23, 59, 59);
                let start = new Date();
                start.setTime(end.getTime() - 3600 * 1000 * 24 * 6);
                start = new Date(start.getFullYear(), start.getMonth(), start.getDate(), 0, 0, 0);
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: '最近一个月',
              onClick(picker) {
                let end = new Date();
                end = new Date(end.getFullYear(), end.getMonth(), end.getDate(), 23, 59, 59);
                let start = new Date();
                start.setTime(end.getTime() - 3600 * 1000 * 24 * 29);
                start = new Date(start.getFullYear(), start.getMonth(), start.getDate(), 0, 0, 0);
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: '最近三个月',
              onClick(picker) {
                let end = new Date();
                end = new Date(end.getFullYear(), end.getMonth(), end.getDate(), 23, 59, 59);
                let start = new Date();
                start.setTime(end.getTime() - 3600 * 1000 * 24 * 90);
                start = new Date(start.getFullYear(), start.getMonth(), start.getDate(), 0, 0, 0);
                picker.$emit('pick', [start, end]);
              }
            }]
        }
      }
    },
    watch: {
      dates: function (newVal, oldVal) {
        this.$emit("update:dateValue", newVal);
      },
    },
    name: "datetime-picker",
    model: {
      prop: 'dateValue',
      event: 'change'
    },
    props: {
      dateValue: {
        type: Array,
        default: []
      }
    },
    methods: {
      reset(val){
        this.dates=val;
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datetime-picker/index.vue